import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { SaveStatePrescriptionLogInput } from './SaveStatePrescriptionLogInput';
import { SaveStatePrescriptionLogOutput } from './SaveStatePrescriptionLogOutput';

export class SaveStatePrescriptionLogService extends HttpServiceBase {

  handle = (input: SaveStatePrescriptionLogInput): Promise<Result<SaveStatePrescriptionLogOutput> | null> => {
    const promise = this.http.post<Result<SaveStatePrescriptionLogOutput>, SaveStatePrescriptionLogInput>(`${this.baseUrlSislogApi}/v2/state-prescription-log`, input);
    return promise;
  }
}